import { Component, inject, input, OnDestroy, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MapService } from '@vectronic/base-map';
import { dsApi, webDtos } from '@vectronic/openApi-admin';
import { DeviceSelectorComponent } from '@vectronic/ui';
import { SelectableDeviceIds } from '@vectronic/util';
import { Subscription } from 'rxjs';

type SelectedId = {
  id: number;
  checked: boolean;
  color?: string;
};

@Component({
  selector: 'sm-shared-list-view',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    DeviceSelectorComponent,
  ],
  templateUrl: './list-view.component.html',
  styleUrl: './list-view.component.scss',
})
export class ListViewComponent implements OnDestroy {
  private getCollarsService = inject(dsApi.Collars);
  private mapService = inject(MapService);

  allDevices = input<SelectableDeviceIds>();
  mapPositions = input<webDtos.MapPositionsList[] | null>();

  getPositionsForDevices = output<SelectedId[]>();
  clearMapPositionsEvent = output();
  colorChanged = output<{ key: number; color: string }>();

  private subscription: Subscription;

  onColorChanged(event: { $event: string; item: SelectedId }) {
    this.updateColor(event.$event, event.item.id);
  }

  private updateColor(color: string, id: number) {
    this.subscription = this.getCollarsService
      .patch(id, {
        color,
        _class: undefined,
      })
      .subscribe(() => this.colorChanged.emit({ key: id, color }));
  }

  setMapFocus(id: number) {
    this.mapService.resetZoomToPositions(id);
  }

  clearMapPositions() {
    this.clearMapPositionsEvent.emit();
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
